<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import Flickity from "flickity";

export default {
  mixins: [fandomBasicMixin],
  mounted() {
    Vue.nextTick(() => {
      if (Fandom.exists(this.content.images)) {
        const carousel = new Flickity(this.$refs["images-with-captions-carousel"], {
          draggable: ">1",
          prevNextButtons: false,
          pageDots: true,
          cellAlign: "left",
          wrapAround: false,
          freeSCroll: false,
          contain: true,
        });
      }
    });
  },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
  },
  computed: { },
};

</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" v-if="isContentVisibleToUser()"  images-with-captions>
    <div class="container py-4">
      <div class="row d-none d-sm-flex justify-content-center">
        <div v-for="picture in content.images" class="col-12 col-sm-5">
          <figure v-if="picture.image">
            <img :src="picture.image.url" class="img-fluid">
            <figcaption class="font-sm pt-2">{{picture.caption}}</figcaption>
          </figure>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-sm-none">
          <div class="images-with-captions-carousel" ref="images-with-captions-carousel">
            <div class="images-with-captions-carousel-item" v-for="(picture, index) in content.images" :key="`carousel-slide-${index}`">
              <div v-if="picture.image" class="picture">
                <div class="position-absolute-center bg-cover-center" :style="{'background-image': getBackgroundUrl(picture.image.url)}"></div>
              </div>
              <div v-if="picture.caption" class="font-sm text-center py-3">{{picture.caption}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[images-with-captions] {

  .flickity-page-dots .dot {
    background: $orange;
    width: 13px;
    height: 13px;
  }

  .images-with-captions-carousel-item {
    width: 100%;

    .picture {
      position: relative;
      width: 100%;
      padding-bottom: 130%;

    }

  }

}
</style>

